import React from 'react'
import { Link } from 'react-router-dom'
import * as qs from 'qs'
import { useFetchPage } from 'hooks'
import styled from '@emotion/styled'
import Button from 'components/Forms/Button'
import { useLocale } from 'hooks'
import { H4Bold } from 'components/Typography/Basic'
import { mediaQueries } from 'devices'
const { REACT_APP_STRAPI_API_URL } = process.env

const RedSquare = () => {
  const { locale } = useLocale()
  const query = qs.stringify({
    populate: '*',
    locale: [locale]
  })
  const fetcher = () =>
    fetch(`${REACT_APP_STRAPI_API_URL}/api/avax-redsquare?${query}`).then(res =>
      res.json()
    )
  const { data } = useFetchPage(['api/redsquare', locale], fetcher)

  return (
    <Knowmorewrapper>
      <div className="purple-bg" />
      <div className="knowmorecontent">
        <H4Bold className="text">{data?.description}</H4Bold>
        <div className="knowmorebtn-wrapper">
          <Link to="/contact">
            <Button className="btnstyleknowmore">{data?.button?.title}</Button>
          </Link>
        </div>
      </div>
    </Knowmorewrapper>
  )
}

export default RedSquare

const Knowmorewrapper = styled.div`
  padding-top: 86px;
  margin-top: 148px;
  position: relative;
  margin-bottom: 100px;
  .purple-bg {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 100%;
    height: 172px;
    background: #1445d7;
    z-index: -1;
  }
  ${mediaQueries.phone} {
    margin-top: 50px;
    margin-bottom: 100px;
  }
  .knowmorecontent {
    max-width: 900px;
    padding: 43px;
    padding-top: 53px;
    padding-bottom: 53px;
    overflow: hidden;
    margin: auto;
    background: #e7303c;
    ${mediaQueries.tabport} {
      width: 90%;
    }
    ${mediaQueries.phone} {
      padding-bottom: 50px;
      padding-right: 20px;
      padding-left: 20px;
      width: 95%;
      margin-top: 20px;
    }
    @media (min-width: 2000px) {
      width: 50%;
    }
    .text {
      text-align: justify;
      ${'' /* max-width: 81.6%; */}
      color: #ffffff;
      font-size: 28px;
      font-weight: 700;
      font-family: 'Roboto', sans-serif;
      ${mediaQueries.tabport} {
        text-align: left;
        max-width: 100%;
      }
    }
  }
  .knowmorebtn-wrapper {
    ${mediaQueries.tabport} {
      max-width: 100%;
    }
  }
  button {
    float: right;
    ${mediaQueries.tabport} {
      float: none;
    }
  }
  ${mediaQueries.tabport} {
    padding: 48px 40px;
  }
  ${mediaQueries.phone} {
    padding: 48px 10px;
    margin-top: 60px;
    padding: 2px;
  }
`
